import store from '../../store/store'

import('./mouse_tooltip.scss')

export default function MouseTooltip(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    this.setContent = content =>{
        $(elements.content).html(content)
    }

    init()

    function init(){
        elements.container = context.createElement('div', 'mouse-tooltip-container')
        elements.content = context.createElement('div', 'tooltip-content')
        $(elements.container).append(elements.content)
        $(document).find('body').append(elements.container)

        

        store.landslideConfigStore.subscribe('SET_OPTION', data=>{
            if(data.option === 'tooltipOptions' && data.value.show === true){
                $(document).on('mousemove', e =>{
                    $(elements.container).css({
                        left: e.clientX + 'px',
                        top: e.clientY + 'px'
                    })
                })
                $(elements.container).addClass('show')
                context.setContent(data.value.content)
            } else {
                $(document).off('mousemove')
                $(elements.container).removeClass('show')
                context.setContent('')
            }
        })
    }
}

MouseTooltip.prototype = Object.create(BaseConstructor.prototype)